import mediaHelper from './styled-media-helper';
import {BreakPoint,width} from './hooks/use-screen-size'

const media = mediaHelper({
  sm: BreakPoint.sm.minWidth,
  md: BreakPoint.md.minWidth,
  lg: BreakPoint.lg.minWidth
});

const mediaSm = media.down('md')
const mediaUpMd = media.up('md')  // >= md
const mediaMd = media.between('md','lg')
const mediaDownMd = media.down('md') // <=md
const mediaLg = media.up('lg')


// export default media;
export {
  media,
  mediaSm,
  mediaUpMd,
  mediaMd,
  mediaDownMd,
  mediaLg,
  width
}
